import styles from "../Tabelas.module.css";
import Container from "../../../../components/components-ui/Container/Container";
import Button from "../../../../components/components-ui/Button/Button";
import { Grid, Col } from "../../../../components/Grid";
import api from "../../../../services/Api";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Table } from "../../../../components/Table";
import { Box } from "@mui/material";
import Loading from "../../../../components/components-ui/Loading/Loading";
import { SelectSearch } from "../../../../components/components-ui/SelectSearch/SelectSearch";

// Colunas da tabela
const columns = [
  {
    column: "Ação",
  },
];

const API_SHOW_PERFIL = "/perfil/show/";
const API_CREATE_PERFIL = "/perfil/create";
const API_EDIT_PERFIL = "/perfil/edit/";
const API_ADICIONAR_ACAO = "/usuarioacao/create";
const API_REMOVER_ACAO = "/usuarioacao/delete";
const API_ACOES_DISPONIVEIS = "/usuarioacao/index/";
const API_SHOW_ACAO_DO_PERFIL = "/usuarioacao/show/";

export default function Action() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [opcaoSelecionada, setOpcaoSelecionada] = useState();
  const [opcaoRemover, setOpcaoRemover] = useState();
  const [acaoDisponivel, setAcaoDisponivel] = useState([]);
  const [acaoPerfil, setAcaoPerfil] = useState([]);
  const [perfil, setPerfil] = useState([]);

  async function getAcao() {
    setIsLoading(true);
    const response = await api.get(API_ACOES_DISPONIVEIS + id);
    setAcaoDisponivel(response.data.data);
    setIsLoading(false);
  }

  async function getAcaoDoPerfil() {
    const response = await api.get(API_SHOW_ACAO_DO_PERFIL + id);
    setAcaoPerfil(response.data.data);
  }

  async function getPerfil() {
    const response = await api.get(API_SHOW_PERFIL + id);
    setPerfil(response.data.data);
  }

  const createPerfil = async (values) => {
    await api
      .post(API_CREATE_PERFIL, {
        perfil: values.nomePerfil,
        tipoMenu: values.tipoMenu,
      })
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          navigate("/usina/perfil");
          return;
        }
        toast.error("Algo de errado aconteceu: " + res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  const editPerfil = async (values) => {
    await api
      .post(API_EDIT_PERFIL + id, {
        perfil: values.nomePerfil,
        tipoMenu: values.tipoMenu,
      })
      .then((res) => {
        if (res.data.error === 0) {
          toast.success(res.data.msg);
          navigate("/usina/perfil");
          return;
        }
        toast.error("Algo de errado aconteceu: " + res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  const adicionarAcao = async () => {
    console.log(opcaoSelecionada);

    if (!opcaoSelecionada) {
      toast.warn("Nenhuma opção selecionada");
      return;
    }

    const data = {
      idAcao: opcaoSelecionada,
      idPerfil: id,
    };

    await api
      .post(API_ADICIONAR_ACAO, data)
      .then((res) => {
        console.log(res);
        if (res.data.error === 0) {
          setAcaoDisponivel(res.data.acoesDisponiveis);
          setAcaoPerfil(res.data.acoesDoPerfil);
          setOpcaoSelecionada("");
          return;
        }
        toast.error(res.data.msg);
        return;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  const aoRemover = async () => {
    console.log(opcaoRemover);

    if (!opcaoRemover) {
      toast.warn("Nenhuma opção selecionada");
      return;
    }

    await api
      .delete(`${API_REMOVER_ACAO}/${opcaoRemover.Id}/${id}`)
      .then((res) => {
        console.log(res);
        if (res.data.error === 0) {
          setAcaoDisponivel(res.data.acoesDisponiveis);
          setAcaoPerfil(res.data.acoesDoPerfil);
          setOpcaoRemover("");
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  function handleChangeRemover(idAcao) {
    const opcao = acaoPerfil.find((opcao) => opcao.IdAcao == idAcao);
    setOpcaoRemover(opcao);
  }

  useEffect(() => {
    if (id) {
      getPerfil();
      getAcao();
      getAcaoDoPerfil();
    }
  }, []);

  const validadtionSchema = Yup.object().shape({
    nomePerfil: Yup.string().required("*Campo Obrigatório"),
    tipoMenu: Yup.string().required("*Campo Obrigatório"),
  });
  return (
    <Container>
      <h3>{id ? "Edição de Perfil" : "Novo Perfil"}</h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{
            codigo: perfil?.IdPerfil || "",
            nomePerfil: perfil?.Perfil || "",
            tipoMenu: perfil?.IdTipoMenu || "",
          }}
          enableReinitialize={true}
          validationSchema={validadtionSchema}
          onSubmit={(values) =>
            id ? editPerfil(values) : createPerfil(values)
          }
        >
          {({ errors, touched, values, isSubmitting }) => (
            <Form style={{ width: "100%" }}>
              {isLoading && id ? (
                <div className={styles.loading}>
                  <Loading />
                </div>
              ) : (
                <Box border={1} padding={2}>
                  <Grid>
                    {id && (
                      <Col size={1}>
                        <label> Código </label>
                        <Field type="text" name="codigo" />
                        {errors.codigo && touched.codigo ? (
                          <span className={styles.alertError}>
                            {errors.codigo}
                          </span>
                        ) : null}
                      </Col>
                    )}
                    <Col size={2}>
                      <label> Nome Perfil </label>
                      <Field type="text" name="nomePerfil" />
                      {errors.nomePerfil && touched.nomePerfil ? (
                        <span className={styles.alertError}>
                          {errors.nomePerfil}
                        </span>
                      ) : null}
                    </Col>
                    <Col size={2}>
                      <label> Tipo Menu </label>
                      <Field
                        name="tipoMenu"
                        component={SelectSearch}
                        options={[
                          { value: 1, label: "Menu Vertical" },
                          { value: 2, label: "Menu Horizontal" },
                        ]}
                      />
                      {errors.tipoMenu && touched.tipoMenu ? (
                        <span className={styles.alertError}>
                          {errors.tipoMenu}
                        </span>
                      ) : null}
                    </Col>
                  </Grid>
                  {id && (
                    <Grid justifyContent={"center"} marginY={2}>
                      <Box border={1} padding={1} height={"200px"} flex={1}>
                        <div style={{ borderBottom: "1px solid black" }}>
                          <span style={{ fontWeight: "bold" }}>
                            Ação Disponivel
                          </span>
                        </div>
                        <select
                          multiple
                          className={styles.list_acoes_select}
                          onChange={(e) => setOpcaoSelecionada(e.target.value)}
                        >
                          {acaoDisponivel.map(
                            ({ Acao, IdAcao, MenuPrincipal }) => (
                              <option
                                key={IdAcao}
                                value={IdAcao}
                                style={{
                                  backgroundColor: MenuPrincipal
                                    ? "#a1d4a2"
                                    : "",
                                }}
                              >
                                {Acao}
                              </option>
                            )
                          )}
                        </select>
                      </Box>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-evenly",
                        }}
                      >
                        <Button
                          type="button"
                          onClick={() => adicionarAcao()}
                          disabled={isSubmitting}
                        >
                          <i
                            class="fas fa-arrow-right"
                            style={{ color: "white" }}
                          ></i>
                        </Button>
                        <Button
                          type="button"
                          onClick={() => aoRemover()}
                          disabled={isSubmitting}
                        >
                          <i
                            class="fas fa-arrow-left"
                            style={{ color: "white" }}
                          ></i>
                        </Button>
                      </div>
                      <Box border={1} padding={1} height={"200px"} flex={1}>
                        <div style={{ borderBottom: "1px solid black" }}>
                          <span style={{ fontWeight: "bold" }}>
                            Ação do Perfil
                          </span>
                        </div>
                        <select
                          multiple
                          className={styles.list_acoes_select}
                          onChange={(e) => handleChangeRemover(e.target.value)}
                        >
                          {acaoPerfil?.map((acao) => (
                            <option
                              key={acao?.IdAcao}
                              value={acao?.IdAcao}
                              style={{
                                backgroundColor: acao?.MenuPrincipal
                                  ? "#a1d4a2"
                                  : "",
                              }}
                            >
                              {acao?.Acao}
                            </option>
                          ))}
                        </select>
                      </Box>
                    </Grid>
                  )}
                  <Grid justifyContent={"center"}>
                    <Button
                      type="submit"
                      title={"Salvar"}
                      disabled={isSubmitting}
                    />
                    <Button
                      type="button"
                      title="Voltar"
                      color="secondary"
                      onClick={() => {
                        navigate("/usina/perfil");
                      }}
                      disabled={isSubmitting}
                    />
                  </Grid>
                </Box>
              )}
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  );
}
